import React from 'react';

import Tooltip, { themes } from '~/App/Components/Tooltip';
import RollUpButton from '~/App/Modules/TodoList/Components/RollUpButton';
import useCurrentUser from '~/react-hooks/use-current-user';
import { useVmPlan } from '~/react-hooks/use-plans';
import { Greet } from '~/types/models';
import { VideoMessagingPlanSlugs } from '~/types/plans';

export type RollUpButtonWithTooltip = {
  greets: Greet[];
};

export default function RollUpButtonWithTooltip({
  greets,
}: RollUpButtonWithTooltip) {
  const vmPlan = useVmPlan();
  const { features } = useCurrentUser();

  const isGrowthPlan =
    vmPlan.slug === VideoMessagingPlanSlugs.GrrrowthMonthly ||
    vmPlan.slug === VideoMessagingPlanSlugs.GrrrowthYearly;
  const rollUpLimit = features.greetRollUpLimit;
  const hasReachedLimit = !!(
    rollUpLimit &&
    greets.length > rollUpLimit &&
    isGrowthPlan
  );

  const tooltip = !hasReachedLimit
    ? 'Merge multiple tasks into one'
    : `Roll ups is limited to ${rollUpLimit} contacts.`;

  return (
    <Tooltip
      id='bulk-select-roll-up'
      body={tooltip}
      placement='bottom'
      opacity={1}
      theme={themes.dark}
    >
      <RollUpButton greets={greets} disabled={hasReachedLimit} />
    </Tooltip>
  );
}
